<template>
    <section class="mt-16">
      <v-row>
        <v-col cols="12" offset="0" md="10" offset-md="1">    
            <v-breadcrumbs
              large
              :items="crumbs"
              divider="/"
              class="pl-0"
            ></v-breadcrumbs>
      
            <h1 class="primary--text">
              <v-icon color="primary">mdi-shield-account</v-icon> <span>Visualização de obra</span>
            </h1>
            <span v-if="work != null">{{work.obra.Codigo}} - {{work.obra.Descricao}}</span>
      
            <div class="mt-16">
              <v-progress-linear v-if="loading"
                indeterminate
                class="global-loader"
              ></v-progress-linear>
      
              <template v-if="loading">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-skeleton-loader
                      type="text"
                    ></v-skeleton-loader>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-skeleton-loader
                      type="text"
                    ></v-skeleton-loader>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-skeleton-loader
                      type="text"
                    ></v-skeleton-loader>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-skeleton-loader
                      type="text"
                    ></v-skeleton-loader>
                  </v-col>
                </v-row>
                <v-row class="mt-6" align="center" justify="space-around">
                  <v-skeleton-loader
                      type="button"
                    ></v-skeleton-loader>
                </v-row>
              </template>
              <Work v-else method="update" :work="work"></Work>
            </div>
          </v-col>
        </v-row>
    </section>
  </template>
  <script>
  import Work from '@/components/Works/Work.vue'
  import ObraAPI from "@/api/Obra.js";
  
  export default {
    components: {
      Work
    },
    data: () => ({
        work: null,
        loading:true
    }),
    mounted(){
  
      if(!this.$store.getters.hasPermission(["super"])) {
        this.$router.push('/admin');
      }
  
      ObraAPI.getObra(this.$route.params.id).then(({data}) => { this.work = data; this.loading = false;});
    },
    methods:{
      
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: 'Dashboard',
            disabled: false,
            to: '/admin',
            exact: true,
          },
          {
            text: 'Consulta de Obras',
            disabled: false,
            to: '/works_consult',
            exact: true,
          },
          {
            text: 'Obra',
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  